import React from 'react';
import {
  Autocomplete,
  TextField,
  Box,
  IconButton,
  Button,
  Tooltip,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const MultipleTagSelect = ({ label, options = [], value = [], onChange,  multiple = true, }) => {
  const handleRemoveTag = (tagToRemove) => {
    const updated = value.filter((tag) => tag !== tagToRemove);
    onChange(updated);
  };

  return (
    <Autocomplete
      multiple={multiple}
      freeSolo={!multiple}
      options={options}
      value={value}
      onChange={(e, newValue) => onChange(newValue)}
      renderTags={() => {
        const visibleTags = value.slice(0, 2);
        const remainingTags = value.slice(2);

        return (
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {visibleTags.map((tag) => (
              <Button
                key={tag}
                variant="outlined"
                size="small"
                sx={{
                  borderRadius: '16px',
                  paddingRight: '4px',
                  textTransform: 'none',
                }}
                endIcon={
                  <IconButton
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveTag(tag);
                    }}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                }
              >
                {tag}
              </Button>
            ))}

            {remainingTags.length > 0 && (
              <Tooltip title={remainingTags.join(', ')}>
                <Button
                  variant="outlined"
                  size="small"
                  sx={{ borderRadius: '16px', textTransform: 'none' }}
                >
                  +{remainingTags.length} more
                </Button>
              </Tooltip>
            )}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder={`Select Your ${label}`} />
      )}
    />
  );
};

export default MultipleTagSelect;
